import { ConfirmPositiveModal } from '@/shared/components/confirmation'

interface Props {
  open: boolean
  onClose: () => void
  memberName?: string
  onConfirm?: () => void
  isPending?: boolean
}

export function ReactivateMemberModal({
  open,
  onClose,
  memberName,
  onConfirm,
  isPending = false,
}: Readonly<Props>) {
  const displayName = memberName?.trim() || 'this team member'

  return (
    <ConfirmPositiveModal
      open={open}
      headline="Reactivate Team Member"
      bodyLines={[
        `Are you sure you want to reactivate ${displayName}? They will regain access to assigned campaigns.`,
        '',
      ]}
      dismissLabel="Cancel"
      confirmLabel="Yes, Confirm Reactivation"
      confirmDisabled={isPending}
      onDismiss={onClose}
      onConfirm={() => onConfirm?.()}
      dialogTestId="reactivate-member-dialog"
    />
  )
}
